import { render, staticRenderFns } from "./pogs-reports__table__column.vue?vue&type=template&id=54988a3c&"
import script from "./pogs-reports__table__column.vue?vue&type=script&lang=js&"
export * from "./pogs-reports__table__column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports